module.exports = __webpack_public_path__ + "static/756f8d1e5e331f99404eddc3e37def544f916007aca5d97347324e626989afb4-803efc0b87703612c82934c3132ef8b8.jpeg";